<div class="supplier-card">
  <!-- company image -->
  <div class="supplier-card__left-section">
    <!-- supplier card logo -->
    <div class="supplier-card__logo-container">
      <img
        class="supplier-card__logo"
        [ngSrc]="
          supplierCardData()?.logo?.cropped_url?.toLowerCase() ||
            supplierCardData()?.logo?.url | imageSource
        "
        [width]="188"
        [height]="188"
        [alt]="supplierCardData().title | translateData" />
    </div>
  </div>

  <!-- company info -->
  <div class="supplier-card__right-section">
    <!-- owner data -->
    <div class="supplier-card__content-header">
      <div class="supplier-card__title-container">
        <!-- country flag -->
        <!-- comment temporary: disable country flag -->
        <!-- @if (supplierCardData()?.country) {
          <div class="supplier-card__country-flag">
            <i
              [class]="
                'flag-icon flags flag:' + supplierCardData()?.country?.iso
              "></i>
          </div>
        } -->
        <pwj-card-title
          class="supplier-card__title"
          [cardTitleData]="cardTitleData"></pwj-card-title>
      </div>

      <!-- see more details btn -->
      <div class="supplier-card__details-url pointer-events-none">
        <pwj-button
          class="supplier-card__details-btn"
          variant="primary"
          size="large"
          icon="chevron-right"
          [rotateIconInRtl]="true"
          [iconReversePosition]="true"
          [disabled]="true">
          {{ 'home.company_details' | translate }}
        </pwj-button>
      </div>
    </div>

    <!-- description -->
    <p class="supplier-card__description">
      @if (
        ((supplierCardData()?.description | translateData) || '').length > 160
      ) {
        {{ (supplierCardData()?.description | translateData)?.slice(0, 160) }}
        ...
      } @else {
        {{ supplierCardData()?.description | translateData }}
      }
    </p>
    <!-- company info -->
    <div class="supplier-card__company-info">
      <!-- main products -->
      @if ((supplierCardData()?.categories || []).length > 0) {
        <ul class="supplier-card__main-categories">
          <!-- title -->
          <li>
            <p class="supplier-card__categories-label">
              {{ 'industries.mainProducts' | translate }}
            </p>
          </li>

          @for (category of supplierCardData()?.categories; track $index) {
            <li>
              <p class="supplier-card__categories-value">
                {{ category?.title || '' | translateData }}
              </p>
            </li>
          }
        </ul>
      }
    </div>
  </div>
</div>
